<template>
	<!-- non toccare lo z-index -->
	<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; z-index: 3000 !important;">
		<div style="background-color: #eeeeee; min-width: 600px">
			<div class="dialog-header" style="min-width: 200px">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{ $t("add-new-payment") }}</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="() => $emit('close')" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>
			<div class="dialog-body">
				<div class="data-item">
					<div class="label">
						<strong>{{ $t("school") }}</strong>
					</div>
					<div class="value">
						<el-select
							v-model="organization"
							:class="{ error: error.indexOf('organization') > -1 }"
							clearable
							filterable
							remote
							value-key="id"
							:disabled="school != undefined"
							:remote-method="getSchool"
							reserve-keyword
							:placeholder="$t('start-typing')"
							style="width: 75%; z-index: 2100 !important;"
						>
							<el-option
								style=" z-index: 2200 !important;"
								v-for="item in schools"
								:key="item.id"
								:label="typeof item.name == 'object' ? item.name.String : item.name"
								:value="item"
							/>
						</el-select>
					</div>
				</div>

				<div class="data-item">
					<div class="label">
						<strong>{{ $t("subscription") }}</strong>
					</div>
					<div class="value">
						<el-select
							v-model="subscription"
							clearable
							filterable
							:placeholder="$t('subscription')"
							value-key="name"
							:class="{ error: error.indexOf('subscription') > -1 }"
							style="width: 75%"
						>
							<el-option v-for="item in subscriptions" :value="item" :key="item.id" :label="item.name">
								<div style="display: flex; width: 100%">
									<span>{{ item.name }}</span>
									<span style="color: gray; margin-left: auto; margin-rigth: 0">{{
										item.duration_month + " " + $t("month")
									}}</span>
								</div>
							</el-option>
						</el-select>
					</div>
				</div>

				<div class="data-item" v-if="subscription">
					<div style="width: 80%; margin-left: auto; margin-right: auto">
						<el-alert
							type="success"
							:title="subscription.name"
							:closable="false"
							style="width: 100%"
							:center="true"
						>
							{{ subscription.duration_month }} {{ $t("month") }} - {{ subscription.price }}
							{{ subscription.currency }} -
							{{ subscription.ticketing ? $t("yes-ticketing") : $t("not-ticketing") }} <br />
							{{ $t("areas") }}: {{ Array.from(subscription.areas, x => x.name).join(", ") }}
						</el-alert>
					</div>
				</div>

				<div class="data-item">
					<div class="label">
						<strong>{{ $t("valid-from") }}</strong>
					</div>
					<div class="value">
						<el-date-picker
							v-model="valid_from"
							:placeholder="$t('select-date')"
							format="dd/MM/yyyy"
							:class="{ error: error.indexOf('valid_from') > -1 }"
							style="width: 75%"
						/>
					</div>
				</div>
				<div class="data-item">
					<div class="label">
						<strong>{{ $t("valid-until") }}</strong>
					</div>
					<div class="value">
						<el-date-picker
							v-model="valid_until"
							:placeholder="$t('select-date')"
							format="dd/MM/yyyy"
							:class="{ error: error.indexOf('valid_until') > -1 }"
							style="width: 75%"
						/>
					</div>
				</div>

				<el-alert
					v-if="another_one"
					:title="$t('another-subscription-active-found')"
					type="error"
					effect="dark"
				>
				</el-alert>
			</div>
			<div class="dialog-footer">
				<div style="margin-left: auto; margin-right: 0px">
					<md-button class="cancel" @click="() => $emit('close')">{{ $t("cancel") }}</md-button>
					<md-button class="add" @click="handleAdd">
						<i class="el-icon-loading" v-if="loading" />
						<span>{{ $t("add") }}</span>
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>
<script>
import axios from "axios"
import { mapActions } from "vuex"
export default {
	name: "payments-add",
	props: ["show", "school"],
	data() {
		return {
			loading: false,
			organization: this.school,
			subscription: undefined,
			valid_until: undefined,
			valid_from: new Date(),
			amount: false,
			another_one: false,
			error: [],

			schools: this.school == undefined ? [] : [this.school],
			subscriptions: []
		}
	},
	created() {
		axios
			.get(process.env.VUE_APP_API_URL + "/api/subscriptions", {
				headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
			})
			.then(res => {
				this.subscriptions = res.data
			})
			.catch(err => console.error(err))
	},
	watch: {
		subscription: function() {
			if (this.subscription != undefined) {
				this.checkDate()
			}
		},
		valid_from: function() {
			this.checkDate()
		}
	},
	computed: {},
	methods: {
		...mapActions({
			doAdd: "payment/doAdd"
		}),
		checkDate() {
			var d = new Date(this.valid_from)
			d.setMonth(d.getMonth() + parseInt(this.subscription.duration_month))
			this.valid_until = d
		},
		getSchool: function(query) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/organizations/search",
					{ query: query },
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => (this.schools = res.data))
				.catch(err => console.error(err))
		},

		handleAdd: function() {
			this.loading = true
			this.error = []
			if (this.valid_until == undefined || this.valid_until <= new Date()) this.error.push("valid_until")
			if (this.organization == undefined) this.error.push("organization")
			if (this.subscription == undefined) this.error.push("subscription")

			if (this.error.length > 0) {
				this.loading = false
				return
			}

			var payload = {
				organization_id: this.organization.id,
				subscription_id: this.subscription.id,
				amount: this.price ? 0.0 : this.subscription.price,
				currency: this.subscription.currency,
				valid_until: this.valid_until,
				valid_from: this.valid_from
			}

			this.add(payload)
		},

		async add(payload) {
			var result = await this.doAdd({
				payload,
				subscription: this.subscription,
				organization: this.organization
			})
			if (result.status) {
				this.$notification("success", this.$t("save-successful"), "", 4000)
				this.$emit("close")
				this.$emit("add", result)
			} else {
				if (result.value.status == 409 && result.value.data == "anotherone-active") this.another_one = true
				this.$notification("error", this.$t("something-goes-wrong"), result.value.data, 0)
			}

			this.loading = false
		}
	}
}
</script>
<style >
.el-select-dropdown {
	z-index: 300000000 !important;
}
</style>
<style scoped lang="scss">
@import "src/assets/scss/my-dialog";
@import "src/assets/scss/my-form";
.error {
	border: 1px solid red;
}
</style>
